import React, { FC } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const HelpdeskDashboardContainer = React.lazy(
  () => import('../../containers/helpdesk-dashboard/helpdesk-dashboard.container')
);

const MyTicketsContainer = React.lazy(
  () => import('../../containers/my-tickets/my-tickets.container')
);

const NewTicketContainer = React.lazy(
  () => import('../../containers/new-ticket/new-ticket.container')
);

const TicketDetailContainer = React.lazy(
  () => import('../../containers/ticket-detail/ticket-detail.container')
);

const ALL_ROLES: UserRole[] = [
  UserRole.SUPER_ADMIN,
  UserRole.ADMIN,
  UserRole.SALES_AGENT,
  UserRole.SALES_MANAGER,
  UserRole.SALES_QUALITY_MANAGER,
  UserRole.SALES_QUALITY_AGENT,
  UserRole.MARKETING_EXECUTIVE,
  UserRole.FINANCE_OFFICER,
  UserRole.E_COMMERCE_AUTO,
  UserRole.E_COMMERCE_FINANCE,
  UserRole.E_COMMERCE_SERVICE_CENTER,
  UserRole.E_COMMERCE_REFERRAL,
  UserRole.E_COMMERCE_MANAGER,
  UserRole.OPERATION_MANAGER,
  UserRole.OPERATION_AGENT,
  UserRole.HR_REPRESENTATIVE,
  UserRole.HR_MANAGER,
  UserRole.HELP_DESK_SUPPORT
];

const ADMIN_ROLES: UserRole[] = [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.HELP_DESK_SUPPORT];

const createProtectedRoute = (component: FC, permittedList: UserRole[]): React.ReactElement => (
  <React.Suspense fallback={<div>Loading...</div>}>
    <DefaultLayout
      authenticationRequired={true}
      permittedList={permittedList}
      component={component}
    />
  </React.Suspense>
);

const ROUTES = APP_ROUTES.HELPDESK_MODULE.CHILDREN as RouteConfig;

export const HelpdeskRoutesConfig: RouteObject[] = [
  {
    index: true,
    // Admins land on dashboard; reporters land on my-tickets
    element: <Navigate to={ROUTES.DASHBOARD.FULL_PATH} />
  },
  {
    path: ROUTES.DASHBOARD.FULL_PATH,
    element: createProtectedRoute(HelpdeskDashboardContainer, ADMIN_ROLES)
  },
  {
    path: ROUTES.ALL_TICKETS.FULL_PATH,
    element: <Navigate to={ROUTES.DASHBOARD.FULL_PATH} />
  },
  {
    path: ROUTES.MY_TICKETS.FULL_PATH,
    element: createProtectedRoute(MyTicketsContainer, ALL_ROLES)
  },
  {
    path: ROUTES.NEW_TICKET.FULL_PATH,
    element: createProtectedRoute(NewTicketContainer, ALL_ROLES)
  },
  {
    path: ROUTES.DETAIL.FULL_PATH,
    element: createProtectedRoute(TicketDetailContainer, ALL_ROLES)
  }
];
